import { Theme } from '@mui/material';

import { ContentfulBackground } from '@/types';
import { resolveContentfulBgColor } from '@/utils';

export const alertBannerCtrStyles = (theme: Theme, background: ContentfulBackground) => ({
	position: 'relative',
	width: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: { xs: '.5rem .75rem .5rem 1.7rem', md: '.5rem 0' },
	height: { xs: '2.75rem', md: '3rem' },
	borderBottom: `1px solid ${theme.palette.neutrals?.primary}`,
	background: resolveContentfulBgColor(background, theme),
});

export const alertMessagesCtrStyles = {
	'&.MuiContainer-root': {
		width: { xs: 'auto', md: '100%' },
		margin: { xs: '0', md: '0 auto' },
	},
};

export const paginationItemsCtrStyles = {
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	maxHeight: '1.25rem',
	position: { md: 'absolute' },
	right: { md: '1.25rem' },
};

export const paginationControlIconStyles = (isDarkBackground: boolean) => ({
	cursor: 'pointer',
	color: isDarkBackground ? 'neutrals.white' : 'text.secondary',
});

export const paginationItemIconStyles = {
	'&.MuiPaginationItem-root': {
		padding: '0',
		marginRight: { xs: '.5rem', md: '.75rem' },
		marginLeft: '0',
		width: '.5rem',
		height: '.5rem',
		minWidth: '0',
		borderRadius: 0,
		alignItems: 'center',
	},
	'&.Mui-selected': {
		backgroundColor: 'transparent',
	},
};
